var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 377,
    height: 136
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__h",
    x1: "11.907%",
    x2: "93.389%",
    y1: "53.556%",
    y2: "48.615%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9F0469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5515F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__c",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__d",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__e",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__f",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__i",
    x1: "42.382%",
    x2: "57.701%",
    y1: "38.207%",
    y2: "55.826%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCB381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EF516B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__k",
    x1: "50%",
    x2: "50%",
    y1: "-40.222%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".03%",
    stopColor: "#A40968"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF3154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__l",
    x1: "9.476%",
    x2: "100%",
    y1: "43.01%",
    y2: "56.99%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EF516B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FCB381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flight-failed_svg__m",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "flight-failed_svg__g",
    d: "M0 0l12.801 37.359a31.724 31.724 0 0030.01 21.439h114.17c8.168 0 16.153-2.42 22.948-6.953l.579-.386a7.931 7.931 0 00.028-13.175l-.805-.542a41.931 41.931 0 00-23.421-7.151H44.068a15.86 15.86 0 01-12.034-5.53L17.884 8.58A23.784 23.784 0 003.648.593L0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__a)",
    d: "M151.353 134.933c2.371-25.333 14.356-38 35.954-38 32.397 0 35.058-35.91 56.842-50.063 21.784-14.153 29.882 9.34 53.586-11.793C321.44 13.943 338.91-4.16 364.404 12.37c16.996 11.019 16.746 51.805-.752 122.358l-212.3.205z",
    opacity: 0.05,
    transform: "translate(0 .943)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__b)",
    d: "M65.745 0c4.482 0 8.338 2.699 10.054 6.571a5.885 5.885 0 013.894-1.466 5.932 5.932 0 015.351 3.388 4.349 4.349 0 011.557-.287c2.187 0 4.001 1.609 4.34 3.715a77.7 77.7 0 001.922 1.69c2.558 2.186 11.54 3.336 26.947 3.45l-33.166-.001-.043.001h-.043l-6.81-.001-.055.001h-.056L52.1 17.06l-.055.001H23.532c9.676-.288 17.53-1.181 23.562-2.681a5.971 5.971 0 01-.985-3.297c0-3.302 2.657-5.978 5.936-5.978 1.406 0 2.698.492 3.715 1.315C57.507 2.63 61.32 0 65.745 0z",
    opacity: 0.1,
    transform: "translate(188 .943)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__c)",
    d: "M19.73 5.057c2.095 0 3.898 1.266 4.7 3.082a2.737 2.737 0 011.82-.689c1.235 0 2.282.816 2.641 1.944A2 2 0 0132 11.057v.029c.127.113.263.23.405.352C33.601 12.464 37.8 13.003 45 13.056H0c4.523-.135 8.194-.554 11.014-1.257a2.799 2.799 0 01-.462-1.546c0-1.548 1.243-2.803 2.775-2.803.657 0 1.262.231 1.737.618a5.137 5.137 0 014.666-3.011z",
    opacity: 0.05,
    transform: "translate(188 .943)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__d)",
    d: "M96.757 106.402c44.602-1.544 87.853-8.914 151.349 7.179 42.33 10.729 75.528 16.887 99.592 18.476H0c34.77-16.074 67.022-24.626 96.757-25.655z",
    opacity: 0.1,
    transform: "matrix(-1 0 0 1 347.698 .943)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__e)",
    d: "M163.612 56.262h1.216v7.337a.608.608 0 11-1.216 0v-7.337z",
    opacity: 0.9,
    transform: "matrix(-1 0 0 1 315.828 52.253)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__f)",
    d: "M162.457 53.878h3.526v6.183a1.764 1.764 0 01-3.526 0v-6.183z",
    opacity: 0.9,
    transform: "matrix(-1 0 0 1 315.828 52.253)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 315.828 52.253)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "flight-failed_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#flight-failed_svg__g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#flight-failed_svg__h)",
    xlinkHref: "#flight-failed_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__i)",
    d: "M51.985 26.856c9.037 2.736 13.448 4.193 13.232 4.37-9.591 7.901-25.751 3.178-30.902 18.275-8.027 23.53-39.56 20.261-50.257 20.261-7.132 0-19.3-12.448-36.507-37.344l2.774-32.975 57.05-9.932L79.876.635l-27.891 26.22z",
    mask: "url(#flight-failed_svg__j)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__k)",
    d: "M13.809 51.25h178.282v19.07H13.809z",
    mask: "url(#flight-failed_svg__j)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M174.715 38.023h18.96v8.036h-18.96a4.017 4.017 0 110-8.036z",
    mask: "url(#flight-failed_svg__j)",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    opacity: 0.6,
    transform: "matrix(-1 0 0 1 250.515 91.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 10.298,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 20.599,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 30.899,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 41.2,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 51.501,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 61.802,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 72.102,
    rx: 1.981
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.962,
    height: 5.562,
    x: 82.403,
    rx: 1.981
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 314.938 86.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.426,
    height: 2.251,
    x: 81.473,
    y: 16.76,
    fill: "#FFF",
    opacity: 0.6,
    rx: 1.125
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.62,
    height: 2.557,
    fill: "#FFA1C7",
    rx: 1.279
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#flight-failed_svg__l)",
    d: "M94.866 20.209h16.39c.626 0 1.133.507 1.133 1.133v5.792c0 .626-.507 1.133-1.132 1.133h-16.39a4.03 4.03 0 110-8.059z",
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 215.576 115.655)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.09,
    cy: 3.099,
    fill: "url(#flight-failed_svg__m)",
    opacity: 0.9,
    rx: 3.09,
    ry: 3.099
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.09,
    cy: 3.099,
    fill: "#FFF",
    rx: 1.358,
    ry: 1.362
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 154.698 115.655)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.09,
    cy: 3.099,
    fill: "url(#flight-failed_svg__m)",
    opacity: 0.9,
    rx: 3.09,
    ry: 3.099
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.09,
    cy: 3.099,
    fill: "#FFF",
    rx: 1.358,
    ry: 1.362
  }))))));
}
export default SvgFlightFailed;